import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import "./chip.css";

export const Chip = ({ active, value, label, onClick }) => {
    return (
        <div 
        className={clsx("chip-root", { active: active })}
        onClick={() => onClick(value)}
        >
            <span className="chip-label">{label}</span>
        </div>
    );
};

Chip.propTypes = {
    active: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};
